/** @private */
export default class MobiledocError extends Error {}
